import {
  Addition,
  City,
  CityEnglish,
  Country,
  Root,
  State,
  Street,
  Zip,
} from './components';

export const AddressFields = {
  Root,
  Street,
  Addition,
  Zip,
  City,
  CityEnglish,
  State,
  Country,
};
